<script setup lang="ts">
    /**
     * This component should only be used within the ExternalVideo component.
     */

    defineProps<{ src: string }>();
</script>

<template>
    <iframe
        :src="src"
        class="iframe"
        title=""
        allow="
            accelerometer;
            autoplay;
            clipboard-write;
            encrypted-media;
            gyroscope;
            picture-in-picture;
            web-share;
            fullscreen;
        "
        referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
</template>
